import { Input } from '@heroui/react';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

export interface SearchInputProps {
  /** Current search value */
  value: string;
  /** Placeholder text for the search input */
  placeholder?: string;
  /** Change handler for search input */
  onChange: (value: string) => void;
  /** Whether the input is disabled */
  disabled?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Aria label for accessibility */
  ariaLabel?: string;
  /** Input size variant */
  size?: 'sm' | 'md' | 'lg';
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  placeholder = 'Search...',
  onChange,
  disabled = false,
  className = '',
  ariaLabel,
  size = 'sm',
}) => {
  return (
    <Input
      type="text"
      placeholder={placeholder}
      value={value}
      onValueChange={onChange}
      startContent={<FiSearch className="text-default-400" />}
      variant="bordered"
      size={size}
      isDisabled={disabled}
      aria-label={ariaLabel || placeholder}
      className={className}
      classNames={{
        input: 'text-foreground bg-transparent px-3 py-2',
        inputWrapper:
          'bg-default-50 border-default-200 hover:border-default-300 focus-within:border-primary shadow-sm hover:shadow-md transition-shadow duration-200',
      }}
    />
  );
};
